import { DIAL_CODES, dialCode } from "@/lib/countries";
import { toE164, KEEP_TRUNK_ZERO } from "@/components/PhoneField";

// Connexion unique (lot 550) : un seul champ « e-mail ou numéro WhatsApp ».
// Détection : une lettre ou « @ » → e-mail ; sinon chiffres (+ espaces, tirets, parenthèses, points) → numéro.
export const detectIdentifierKind = (raw) => {
  const s = (raw || "").trim();
  if (!s) return "";
  if (/[a-z@]/i.test(s)) return "email";
  if (/^[+\d(][\d\s().-]*$/.test(s)) return "phone";
  return "";
};

export const isValidEmail = (s) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((s || "").trim());

// Lot 658 — touches « - . ( ) » du clavier téléphone (ou collage « +243-812-… ») : retirées à la frappe tant que la
// saisie ne contient que des caractères de numéro (un e-mail n'est jamais touché).
const PHONE_CHARS_ONLY = /^[\d\s+().-]+$/;
export const stripPhonePunctuation = (raw) => (raw && PHONE_CHARS_ONLY.test(raw) ? raw.replace(/[-.()]/g, "") : raw || "");

// Indicatifs partagés (+1, +7) : on affiche le pays principal (le numéro enregistré est le même quel que soit le drapeau).
const DIAL_PRIMARY = { "1": "US", "7": "RU" };
// Pays où le « 0 » après l'indicatif fait partie du numéro : KEEP_TRUNK_ZERO (PhoneField) — partout ailleurs c'est le préfixe national à retirer.

// Numéro saisi en international (+243…, 00243…) → ISO du pays (indicatif le plus long qui correspond).
export const isoFromE164 = (e164) => {
  const digits = (e164 || "").replace(/^\+|^00/, "").replace(/\D/g, "");
  let best = "";
  for (const [iso, dial] of Object.entries(DIAL_CODES)) {
    if (digits.startsWith(dial) && dial.length > dialCode(best).length) best = iso;
  }
  return (best && DIAL_PRIMARY[dialCode(best)]) || best;
};

// Numéro tel que tapé + pays choisi → { iso, national, e164 }. « + » ou « 00 » en tête = international, le pays
// choisi n'est alors pas utilisé ; sinon le numéro est national dans le pays choisi. Dans les deux cas le « 0 » de
// tête national recopié après l'indicatif est retiré (+33 06… → +33 6…), sauf Italie.
export const phoneFromInput = (raw, iso) => {
  const s = (raw || "").trim();
  const intl = s.startsWith("+") || s.startsWith("00");
  if (intl) {
    const digits = s.replace(/^\+|^00/, "").replace(/\D/g, "");
    const detected = isoFromE164(digits) || iso;
    const dial = dialCode(detected);
    const hasDial = !!dial && digits.startsWith(dial);
    let national = hasDial ? digits.slice(dial.length) : digits;
    if (hasDial && !KEEP_TRUNK_ZERO.has(detected)) national = national.replace(/^0+/, "");
    const full = hasDial ? dial + national : digits;
    const e164 = full.length >= 8 && full.length <= 15 ? `+${full}` : "";
    return { iso: detected, national, e164, candidate: full ? `+${full}` : "" };
  }
  const national = s.replace(/\D/g, "");
  const e164 = toE164(iso, national);
  return { iso, national, e164: e164.replace(/\D/g, "").length >= 8 ? e164 : "", candidate: e164 };
};

// Connexion mémorisée (lot 552) : dernier e-mail / numéro connecté AVEC SUCCÈS sur cet appareil, proposé en un tap.
export const REMEMBER_KEY = "yalola.lastIdentifier";
export const loadRememberedIdentifier = () => {
  try {
    const v = JSON.parse(localStorage.getItem(REMEMBER_KEY) || "null");
    return v && (v.kind === "email" || v.kind === "phone") && typeof v.value === "string" && v.value ? v : null;
  } catch { return null; }
};
export const saveRememberedIdentifier = ({ kind, value, first_name = "" }) => {
  if (!value || (kind !== "email" && kind !== "phone")) return;
  try { localStorage.setItem(REMEMBER_KEY, JSON.stringify({ kind, value: kind === "email" ? value.trim().toLowerCase() : value.trim(), first_name: (first_name || "").trim().slice(0, 40), at: Date.now() })); } catch { /* noop */ }
};
export const forgetRememberedIdentifier = () => { try { localStorage.removeItem(REMEMBER_KEY); } catch { /* noop */ } };
